import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import { getPath } from '@services/RouteService/paths';

import {
    DownloadCaseContentWrapper,
    StyledText,
    StyledTitle,
} from '@domains/download-case-pdf/DownloadCaseContent.styled';

import {
    DownloadPdfButton,
    FilePasswordInfo,
    FilePasswordProtectInfo,
    FilePasswordText,
    FilePasswordWrapper,
} from './DownloadCaseContentFilePage.styled';

interface LocationState {
    pdfPassword: string;
    pdfUrl: string;
}

export const DownloadCaseContentFilePage = () => {
    const { t } = useTranslation();
    const location = useLocation();

    const state = location.state as LocationState;

    const pdfPassword = state?.pdfPassword;
    const pdfUrl = state?.pdfUrl;

    const handleDownloadPdf = () => {
        window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    };

    if (!pdfPassword || !pdfUrl)
        return <Navigate to={getPath({ path: '/auth/welcome' })} />;

    return (
        <DefaultLayout>
            <Container>
                <ContainerInner>
                    <ContainerSection>
                        <DownloadCaseContentWrapper>
                            <StyledTitle>
                                {t('DOWNLOAD_CASE_CONTENT_TITLE')}
                            </StyledTitle>
                            <StyledText>
                                {t('DOWNLOAD_CASE_CONTENT_SUBTITLE_2')}
                            </StyledText>
                            <DownloadPdfButton
                                onClick={handleDownloadPdf}
                                testId="rclboa4"
                                variant="primary"
                            >
                                {t('DOWNLOAD_PDF')}
                            </DownloadPdfButton>

                            <FilePasswordWrapper>
                                <FilePasswordInfo>
                                    {t('FILE_PASSWORD_TEXT')}: *
                                </FilePasswordInfo>
                                <FilePasswordText>
                                    {pdfPassword}
                                </FilePasswordText>
                            </FilePasswordWrapper>
                            <FilePasswordProtectInfo>
                                * {t('FILE_PASSWORD_INFO')}
                            </FilePasswordProtectInfo>
                        </DownloadCaseContentWrapper>
                    </ContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
